var _module_exports = "<div class=\"sf-analytics-function-description\">\n    Calculates the rate per second of the given input stream\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/RATE/config.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;